export default __webpack_public_path__ + "static/media/menu__content__ads.3d77eaab.png";